/*
 * @Author: ken yang
 * @Date: 2022-10-31 18:06:27
 * @LastEditTime: 2022-11-11 11:50:27
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_h5/src/utils/winMes.js
 */
const ready = {}
const postChildTasks = {}
const iosSymbolEventMap = {
  toTrade: 'toTradeIOS',
  toStockTrade: 'toStockTradeIOS',
  toContract: 'toContract',
  toStockContract: 'toStockContract',
}
const postParent = (e, d) => {
  const o = {
    event: e,
    data: d,
  }
  const postMap = {
    h5: (d) => parent.postMessage(d, '*'),
    android: (d) => {
      // 检查原生方法是否存在，不存在则降级到 h5 模式
      if (typeof app !== 'undefined' && typeof app.callNative === 'function') {
        app.callNative(d)
      } else {
        console.warn('app.callNative 不可用，降级到 h5 模式')
        parent.postMessage(d, '*')
      }
    },
    ios: (d) => {
      // 检查原生方法是否存在，不存在则降级到 h5 模式
      if (window?.webkit?.messageHandlers?.Param?.postMessage) {
        window.webkit.messageHandlers.Param.postMessage(d)
      } else {
        console.warn('iOS messageHandlers 不可用，降级到 h5 模式')
        parent.postMessage(d, '*')
      }
    },
  }
  const iosEvent = iosSymbolEventMap[e]
  if (platform == PLATFORM_IOS && iosEvent && isString(d)) {
    const iosPayload = {
      event: iosEvent,
      data: {
        symbol: d
      },
    }
    console.log('--postParent--', JSON.stringify(iosPayload))
    postMap[platform](JSON.stringify(iosPayload))
    return
  }
  console.log('--postParent--', JSON.stringify(o))

  postMap[platform](JSON.stringify(o))
}

const postChild = (id, e, d) => {
  const el = document.getElementById(id)
  const o = {
    event: e,
    data: d,
  }
  const runTask = () => {
    console.log('JSON.stringify(o)', JSON.stringify(o))
    el.contentWindow.postMessage(JSON.stringify(o), '*')
  }
  if (ready[id]) {
    runTask()
  } else {
    if (!postChildTasks[id]) {
      postChildTasks[id] = []
    }
    postChildTasks[id].push(runTask)
    console.log('postChildTasks[id]', postChildTasks, id)
  }
}

const fchildLoadEvent = (data) => {
  ready[data] = true
  const tasks = postChildTasks[data] || []
  for (let i = 0; i < tasks.length; i++) {
    const task = tasks[i]
    console.log('task', task)
    task()
  }
  postChildTasks[data] = []
}

const initEvent = () => {
  eventBus.on('toRouter', toRouter)
  eventBus.on('updateUSDTAsset', value => {
    console.log('++updateUSDTAsset++', value)
    const userStore = useUserStore()
    userStore.usdtAsset = value
  })
  eventBus.on('updateToken', token => {
    console.log('++token++', token)
    const userStore = useUserStore()
    userStore.token = token
    localStorage.token = token
  })
  // postParent('updateToken')
}

const emit = (event, d) => {
  const data = isJsonString(d) ? JSON.parse(d) : d
  eventBus.emit(event, data)
}

const init = (cb) => {
  const { winId } = getUrlQuery()
  initEvent()
  if (winId) {
    window.addEventListener('load', (d) => {
      postParent('fchildLoad', d.currentTarget.winId)
    }, false)
  }

  window.addEventListener('message', (mData) => {
    // console.log('原生 app to H5 mData', mData)
    try {
      let d = mData.data
      if (isEmpty(mData) || isEmpty(d)) {
        return
      }

      d = isJsonString(d) ? JSON.parse(d) : d
      let event
      let data
      if (isObject(d)) {
        event = d.event
        data = d.data
      } else {
        event = String(d)
      }
      if (event == 'fchildLoad') {
        fchildLoadEvent(data)
      } else {
        eventBus.emit(event, data)
      }
    } catch (error) {
      console.log('原生 app to H5 mData error', error)
    }
  }, false)
}

export default {
  postParent,
  postChild,
  init,
  emit,
}
